export default __webpack_public_path__ + "static/media/Amethyst-Drop-Hoop-Earrings.4a277f37.jpg";